<template>
  <div class="dialog dialog-web-uploader   dialog-blue h5-uploader upload-progress" id="web-uploader" v-show="showProgress">
    <div class="dialog-header">
      <div style="width: 90%;">
        <span class="dialog-header-title"><em class="select-text">{{title}}</em></span>
      </div>
      <div class="header-btn" align="right">
        <i v-if="showUploaderBody" @click="miniSize" class="el-icon-remove" style="margin-right: 12px;"></i>
        <i v-if="!showUploaderBody" @click="maxSize" class="el-icon-circle-plus" style="margin-right: 12px;"></i>
        <i @click="close" class="el-icon-circle-close"></i>
      </div>
    </div>
    <div class="upload-body" content="center" v-if="showUploaderBody">
      <table width="100%" class="table-progress">
        <tr>
          <th>文件名</th>
          <th>文件大小</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
        <tr v-if="tableData !== null">
          <td>{{tableData.name}}</td>
          <td>{{tableData.size}}</td>
          <td>{{progress}}</td>
          <td v-if="!isUploaded"><el-button type="text" :disabled="cancelUploadFlag" @click="handleCancel(item)">取消</el-button></td>
          <td v-else><i class="el-icon-success"></i></td>
        </tr>
      </table>
    </div>

  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
// import {getFileSize} from '../../utils/utils.js'
import ct from '../../utils/constant.js'
export default {
  data () {
    return {
      isUploaded: false,
      cancelUploadFlag: false,
      showUploaderBody: true,
      progress: 0,
      timeOut: null
    }
  },
  watch: {
    'uploadedFile': {
      handler: function (val) {
        this.progress = 0
        this.isUploaded = false
        this.cancelUploadFlag = false
        this.hideOverflow()
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(['setShowProgress', 'setFilesList', 'setCurrentDirGuid', 'setNetDiskSpaceUsed', 'setUploadCode']),
    handleClick (row) {},
    handleCancel (row) {
      this.progress = '已取消'
      // this.isCancelUploaded = false
      this.cancelUploadFlag = true
      clearTimeout(this.timeOut)
      this.uploadFileRequest('cancelUpload?fileGUID=' + this.uploadRequestData.fileGUID, null).then(res => {
        if (res && res.data.code === 0) {
          this.setUploadCode(Math.random() * 10000)
        }
      })
    },
    miniSize () {
      this.showUploaderBody = false
    },
    maxSize () {
      this.showUploaderBody = true
    },
    close () {
      this.setShowProgress(false)
    },
    getUploadProgress (callback) {
      if (this.uploadRequestData.fileGUID) {
        this.uploadFileRequest('uploadProgress?fileGUID=' + this.uploadRequestData.fileGUID, null).then(res => {
          if (res && res.data.code === 0) {
            let result = res.data.result
            callback && callback(new Error(result * 100 + '%'))
            this.progress = result * 100 + '%'
            if (this.cancelUploadFlag) {
              this.progress = '已取消'
            }
            if (result >= 1) {
              this.setUploadCode(Math.random() * 10000)
              this.isUploaded = true
              clearTimeout(this.timeOut)
              let file = this.fileRouterList[this.fileRouterList.length - 1]
              this.postRequest('loadFilesByFileGuid', {startIndex: 0, pageSize: 0, orderColumn: ct.OrderColumn.updateDT, isDesc: true, parentGuid: file.fileGuid}).then(res => {
                if (res && res.data.code === 0) {
                  this.setFilesList(res.data.result)
                  this.getRequest('loadCloudCustomerInfo').then(res => {
                    if (res && res.data.code === 0) {
                      this.setNetDiskSpaceUsed(res.data.result)
                    }
                  })
                }
              })
            }
          } else {
            clearTimeout(this.timeOut)
          }
        })
      }
    },
    time (res) {
      if (this.cancelUploadFlag) {
        clearTimeout(this.timeOut)
        return res
      }
      this.timeOut = setTimeout(() => {
        this.getUploadProgress(pro => {
          if (!pro) {
            clearTimeout(this.timeOut)
          }
          // res.size = util.getFileSize(res.size)
        })
        this.time()
      }, 2000)
      return res
    }
  },
  computed: {
    ...mapState(['showProgress', 'uploadedFile', 'uploadRequestData', 'fileRouterList', 'uploadCode']),
    tableData () {
      let res = this.uploadedFile
      // console.log('upload-progress')
      if (res !== null) {
        res = this.time(res)
      }
      return res
    },
    title () {
      if (this.isUploaded) {
        return '上传完成'
      }
      return '文件上传中'
    }
  }
}
</script>
<style>
  .dialog.dialog-web-uploader, .dialog.flash-uploader {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border: 1px solid #e2e2e2;
    box-shadow: 0 0 10px #ccc;
    // margin-bottom: -2px;
  }

  .upload-progress {
    width: 633px;
    top: auto;
    bottom: 0px;
    left: auto;
    right: 30px;
    display: block;
    visibility: visible;
    z-index: 3000;
    position: absolute;
    background-color: #fff;
  }

  .dialog-header {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid gainsboro;
    margin: 12px;
  }

  .header-btn {
    float: right;
    position: relative;
  }

  .upload-body {
    text-align: center;
    display:flex;
    justify-content:center;
    align-items:center;
    margin-bottom: 20px;
  }

  .table-progress
  {
    border-collapse: collapse;
    margin: 0 auto;
    text-align: center;
  }
  .table-progress td, table th
  {
    border-bottom: 1px solid gainsboro;
    color: #666;
    height: 30px;
  }
  .table-progress tr {
    height: 45px;
    line-height: 45px;
  }
  .table-progress thead th
  {
    background-color: #CCE8EB;
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/uploadProgress/uploadProgress.vue